import { httpsCallable } from "firebase/functions";
import { functions } from "../config";

interface GetTextsRequest {
  variant: string;
  overrideId?: string;
}

interface GetTextsResponse {
  keys: Record<string, string>;
}

const getTextsCallable = httpsCallable<GetTextsRequest, GetTextsResponse>(
  functions,
  "getTexts"
);

/**
 * Fetches merged translation keys from the backend. Throws when the call
 * fails — there is no fallback bundle (dev-only path; prod bakes texts).
 */
export async function fetchTexts(
  variant: string,
  overrideId?: string
): Promise<Record<string, string>> {
  const req: GetTextsRequest = { variant };
  if (overrideId) req.overrideId = overrideId;
  const { data } = await getTextsCallable(req);
  return data.keys;
}
